import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

import Search from 'common/components/elements/inputs/search';
import CircleLoader from 'common/components/elements/loader/circle';
import Filter from 'common/components/modules/filter';
import StoryCard from 'common/components/modules/story-card';
import Button from 'common/components/elements/buttons/primary';
import AddNewStory from 'admin/views/add-new-story';
import Icon from 'common/components/elements/icons';
import Modal from 'common/components/modules/modal';
// import NoMoreResults from 'common/components/modules/no-more-results';
import EmptyState from 'common/components/modules/empty-states';
import ModalUrlHelper from 'common/utils/ModalUrlHelper.js';
import StoryPlayer from 'common/components/modules/story-player';
import Carousel from 'common/components/modules/carousel';
import { isMobileAndTablet, moreInfoProps } from 'common/utils/utils';
import PinLabel from "common/components/modules/pin-label";
import CountState from 'admin/views/media-modules/count-state';
import cx from 'classnames'
import   ReorderingContent  from 'admin/views/reorder-content';
import  {  SortableItem }  from 'admin/views/reorder-content';
import ResponsiveFilter from 'common/components/responsive/filter';
import Intercom from 'common/utils/Intercom';
import { ARTICLE_ID_ON_STORIES } from 'common/utils/intercom-articles';
import classNames from 'classnames';

class Stories extends Component {
   static propTypes = {
      onStoriesSearch: PropTypes.func,
      onSelectFilter: PropTypes.func,
      stories: PropTypes.array,
      storyPublished: PropTypes.bool,
      deleteStory: PropTypes.bool,
      onClickComment: PropTypes.func,
      onClickLike: PropTypes.func,
      onClickJoin: PropTypes.func,
      onClickShare: PropTypes.func,
      onDeleteStory: PropTypes.func,
      onImageChanges: PropTypes.func,
      isLoading: PropTypes.bool,
      isLastPage: PropTypes.bool,
      endList: PropTypes.bool,
      isEmpty: PropTypes.bool,
      onVideoChange: PropTypes.func,
      openAddModal: PropTypes.func,
      nextPage: PropTypes.func,
      getStoryById: PropTypes.func,
      activeStory: PropTypes.object,
      isLoadingStory: PropTypes.bool,
      addNewStoryState: PropTypes.bool,
      isFetchingDelete: PropTypes.bool,
      openDeleteConfirmModal: PropTypes.func,
      openModalByUrl: PropTypes.bool,
      handleCloseModalByUrl: PropTypes.func,
      handleOpenFullScreen: PropTypes.func,
      onCommentsClick: PropTypes.func,
      screen: PropTypes.number,
      isUploading: PropTypes.bool,
      editStory: PropTypes.func,
      pinStory: PropTypes.func,
      onClickOpenTips: PropTypes.func,
      onClickSetId: PropTypes.func,
      allowAddContent: PropTypes.bool,
      countState: PropTypes.object,
      isReorderMode: PropTypes.bool,
      setReorderMode: PropTypes.func,
      onSortEnd: PropTypes.func,
      onSimpleFilter: PropTypes.func,
      filters: PropTypes.object,
      onClickPreview: PropTypes.func,
      isDemoMode: PropTypes.bool,
      isInsideModal: PropTypes.bool,
      selections: PropTypes.array,
      onSelectItem: PropTypes.func,
   };

   constructor(props) {
      super(props);
      this.state = {
         storyPublished: false,
         deleteStory: props.deleteStory,
         isFullScreen: false,
         isMultiple: false,
         deleteId: null,
         imageIndex: null,
         type: null,
         openOptionsModal: false,
         id: null,
         draggableItem: null,
      };
      this.searchText = ''
      this.activeStory = []
   }

   componentDidMount() {
      const { storyPublished } = this.props;
      if(storyPublished) {
         this.setState({
            storyPublished,
         }, () => {
            setTimeout(() => {
               this.setState({
                  storyPublished: false,
               });
            }, 1500);
         });
      }
      window.addEventListener('click', () => {
         // onCloseAddNewStory();
      });
   }

   openAddModal = (value) => {
      this.setState({ addNewStoryState: value })
   }
   nextStory = async (n) => {
      const { activeStory, getStoryById, nextPage } = this.props;
      let data = []
      const { stories } = this.props;
      data = stories
      if(stories && !!stories.length) {
         const findIndex = stories.findIndex(story => story.id === activeStory.id);
         if(stories.length - 1 === findIndex) {
            await nextPage()
            data = this.props.stories
         }
         const { id, type } = data[findIndex + n] || {};
         if(typeof id === 'number') {
            await getStoryById(id);
            this.setState(() => ({
               openModalByUrl: true,
               storyType: type,
            }), async () => {
               const modalParams = {
                  id,
                  type,
               };
               ModalUrlHelper.defineAction(modalParams);
            });

         } else {
            return
         }
      }
   }

   openOptionsModal = (value, id = null) => {
      this.setState({ id, openOptionsModal: value })
   }

   render() {
      const {
         stories,
         onStoriesSearch,
         onSelectFilter,
         onClickComment,
         onClickLike,
         onClickJoin,
         onClickShare,
         onDeleteStory,
         isLoading,
         isLastPage,
         endList,
         isEmpty,
         onImageChanges,
         onVideoChange,
         activeStory,
         isLoadingStory,
         addNewStoryState,
         openAddModal,
         isFetchingDelete,
         handleCloseModalByUrl,
         openModalByUrl,
         handleOpenFullScreen,
         onCommentsClick,
         screen,
         openDeleteConfirmModal,
         isUploading,
         editStory,
         pinStory,
         onClickOpenTips,
         onClickSetId,
         allowAddContent,
         countState,
         isReorderMode,
         setReorderMode,
         onSortEnd,
         onSimpleFilter,
         filters,
         onClickPreview,
         isDemoMode,
         isInsideModal,
         selections,
         onSelectItem,
      } = this.props;
      const {
         storyPublished,
         deleteId,
         openOptionsModal,
         id,
         draggableItem,
      } = this.state;

      const allSorts = [
         { name: 'Newest', value: 'date_added:desc' },
         { name: 'Oldest', value: 'date_added:asc' },
         { name: 'Most liked', value: 'likes_count:desc' },
         { name: 'Most viewed', value: 'views_count:desc' },
         // { name: 'Name: A - Z', value: 'name:asc' },
         // { name: 'Name: Z - A', value: 'name:desc' },
         // { name: 'Comments: Highest to lowest', value: 'comments_count:desc' },
         // { name: 'Comments: Lowest to highest', value: 'comments_count:asc' },
      ]

      const filter = [
         { value: 'all', name: 'All stories', icon: '', filter_type: 'type' },
         { value: 'image', name: 'Photos', icon: '', filter_type: 'type' },
         { value: 'video', name: 'Videos', icon: '', filter_type: 'type' },
      ];
      const desktopType = screen > 700 ? 'desktop' : 'mobile';
      function onFilterSelect(value, type) {
         let filterValue = value;
         if(filters?.type === value){
            filterValue = 'all';
         }
         onSelectFilter(type, filterValue);
      }

      return (
         <div
            role='presentation'
            onClick={ () => this.openOptionsModal(false) }
            className={ classNames({
               'h-full relative stories-list-content w-full': true,
               'min-h-[101%]': !endList && !isLastPage,
            }) }
         >
            <div
               className={
                  cx({
                     'flex flex-col gap-6': true,
                     'min-h-full': isInsideModal,
                  })
               }
            >
               <div
                  className={
                     cx({
                        'mt-8 mx-6 flex flex-col gap-2': true,
                        '!mt-6 !mx-4 !gap-4': screen <= 700,
                     })
                  }
               >

                  {
                     !isInsideModal && (
                        <div
                           className={
                              cx({
                                 'flex flex-row-reverse justify-between w-full ': true,
                                 'flex-col gap-2': screen < 900,
                              })
                           }
                        >
                           <Button
                              classNames='flex flex-reow **gap-2 px-[14px] py-2 max-w-[200px]'
                              text='More info on stories'
                              textColor='action'
                              backgroundColor='transparent'
                              textSize='small'
                              iconName='attention-outline'
                              iconPosition='left'
                              fontIconColor='action'
                              fontIconSize='base'
                              primaryColor
                              textMarginX='0'
                              { ...moreInfoProps() }
                              onClick={ () => Intercom.showArticle(ARTICLE_ID_ON_STORIES) }
                           />
                           {
                              allowAddContent &&
                              <div className={
                                 cx({
                                    'flex flex-row gap-y-2 gap-x-4 md:flex-wrap max-[800px]:flex-col flex-1': true,
                                    '!flex-col': screen <= 700,
                                 })
                              }>
                                 <Button
                                    text='Add new story'
                                    onClick={ (e) => { openAddModal(true) } }
                                    iconName='add'
                                    iconPosition='left'
                                    primaryColor
                                    borderRadius='large'
                                    textSize='base'
                                    classNames='px-5 py-[10px] flex flex-row gap-2 whitespace-nowrap h-11 max-w-[180px]'
                                    textMarginX='0'
                                    disabled={ isReorderMode || isDemoMode }
                                    dataToolTipContent={ isDemoMode ? 'Not available in demo' : undefined }
                                 />
                                 {/* <Button
                                 text='Bulk select'
                                 onClick={ (e) => {  } }
                                 iconName='pencil'
                                 fontIconSize='extraLarge'
                                 iconPosition='left'
                                 borderRadius='large'
                                 backgroundColor='major-dark'
                                 textColor='major'
                                 fontIconColor='major'
                                 textSize='base'
                                 classNames='px-5 py-[10px] flex flex-row gap-2 border border-divider h-11 whitespace-nowrap max-w-[133px]'
                                 textMarginX='0'
                              /> */}
                                 <Button
                                    text={ isReorderMode ? 'Done' : 'Reorder' }
                                    onClick={ setReorderMode }
                                    iconName={ isReorderMode ? '' : 'drag' }
                                    iconPosition='left'
                                    borderRadius='large'
                                    backgroundColor={ isReorderMode ? '' : 'major-dark' }
                                    textColor='major'
                                    fontIconColor='secondary'
                                    textSize='base'
                                    classNames={ cx({
                                       'px-5 py-[10px] flex flex-row gap-2 border border-divider h-11 !w-[fit-content] whitespace-nowrap ': true,
                                       'hover:!bg-hover intercom-reorder-content': !isReorderMode,
                                    }) }
                                    textMarginX='0'
                                    primaryColor={ isReorderMode }
                                 />
                                 {
                                    isReorderMode &&
                                    <Button
                                       text='Preview on my site'
                                       onClick={ onClickPreview }
                                       iconName='go-to'
                                       fontIconSize='extraLarge'
                                       iconPosition='left'
                                       borderRadius='large'
                                       backgroundColor='major-dark'
                                       textColor='major'
                                       fontIconColor='secondary'
                                       textSize='base'
                                       classNames='px-5 py-[10px] flex flex-row gap-2 border border-divider h-11 !max-w-[fit-content] hover:!bg-hover whitespace-nowrap'
                                       textMarginX='0'
                                    />
                                 }
                                 {
                                    countState && (
                                       <CountState
                                          state={ countState }
                                          type={ isReorderMode ? `${ stories?.length > 1 ? 'stories' : 'story' } can be reordered` : 'story' }
                                          className='ml-2 whitespace-nowrap !justify-start'
                                          hideTooltip={ isReorderMode }
                                       />
                                    )
                                 }
                              </div>
                           }
                        </div>
                     )
                  }
                  <div
                     className='flex justify-between max-md:flex-col gap-4'
                  >
                     <div className='flex flex-1 flex-wrap justify-between gap-2 max-[800]:flex-col'>
                        <Filter
                           multipl={ true }
                           overflow='hidden'
                           data={ filter }
                           onCancelFilter={ onFilterSelect }
                           onSelectFilter={ (value, type) => {
                              this.searchText = 'filter'
                              onFilterSelect(value, type)
                           } }
                           activeFilter={ filters?.type ?? 'all' }
                           hideCancelButton
                           classNames='!m-0 !h-10 py-2 px-[18px] text-base font-medium'
                           className='!w-[fit-content] !h-[fit-content]'
                           flexClassNames='gap-2 h-10 !p-0'
                           activeBackground='action'
                           activeTextClassName='text-major-dark'
                           disabled={ isReorderMode }
                        >
                        </Filter>
                        <ResponsiveFilter
                           name='Sorting'
                           type='sort'
                           data={ allSorts }
                           desktopType={ desktopType }
                           onFilterChange={ (value, name) => onSimpleFilter(name, value, 'sortBy') }
                           hasClearButton={ false }
                           isAutoSave
                           onClickClear={ () => {
                              onSimpleFilter('', 'date_added:desc', 'sortBy')
                           } }
                           hasFilterButtonContent={ false }
                           activeSelectedValue={  {
                              name: allSorts?.find(it => it.value === filters?.sortBy)?.value === allSorts[0].value ? '' : allSorts?.find(it => it.value === filters?.sortBy)?.name,
                              value: allSorts?.find(it => it.value === filters?.sortBy)?.value || allSorts[0].value,
                           } }
                           height='10'
                           contentStyles={ {
                              right: '0px',
                              top: '44px',
                              zIndex: 1000,
                              width: '200px',
                           } }
                           filterClassName='flex-none'
                           disabledState={ isReorderMode ? ['likes_count:desc', 'views_count:desc'] : [] }
                           labelTooltipText='This view cannot be reordered'
                        />
                     </div>
                     <div
                        className={
                           cx({
                              '!w-full': true,
                              'max-w-[320px]': screen > 768,
                           })
                        }
                        role='presentation'
                        onClick={ (e) => {
                           if(isReorderMode) {
                              return
                           }
                        } }
                     >
                        <Search
                           onChange={ (value) => {
                              this.searchText = value
                              onStoriesSearch('search', value)
                           } }
                           placeholder='Search stories'
                           version='2'
                           value={ filters?.search }
                           disabled={ isReorderMode  }
                        />
                     </div>
                  </div>
               </div>
               {
                  isLoading && !isEmpty && (
                     <div
                        style={ { minHeight: isInsideModal ? 'calc(100% - 88px)' : 'calc(100vh - 321px)' }  }
                        className={
                           cx({
                              'w-full items-center justify-center flex h-full': true,
                              'm-auto': isInsideModal,
                           })
                        }
                     >
                        <CircleLoader />
                     </div>
                  )
               }
               {
                  !isLoading && !isEmpty && (
                     <ReorderingContent
                        contentType='stories'
                        onSortEnd={ onSortEnd }
                        setDraggableItem={ (value) => {
                           this.setState({
                              ...this.state,
                              draggableItem: value,
                           })
                        } }
                        data={ stories }
                     >
                        {
                           stories && stories.map((storyCard, index) => {
                              return (
                                 <SortableItem
                                    key={ storyCard.id }
                                    className='relative'
                                    index={ index }
                                    id={ storyCard.id }
                                    isRotate={ draggableItem === index }
                                    type='stories'
                                    isReorderMode={ isReorderMode }
                                    disabled={ isReorderMode && storyCard.is_pinned }
                                    disabledState={ isReorderMode && storyCard.is_pinned }
                                    tooltiptext='pinned'
                                 >
                                    <div className={ `${ draggableItem === index ? '!rotate-2' : '' }` }>
                                       {
                                          isFetchingDelete && deleteId === storyCard.id ?
                                             <div
                                                key={ storyCard.id }
                                                className=' mb-5 rounded-lg flex-col bg-secondary mx-4 flex justify-center items-center h-full' style={ { height: '400px' } }
                                             >
                                                <CircleLoader size='10' />
                                             </div>
                                             :
                                             <div
                                                key={ storyCard.id }
                                                className={
                                                   cx({
                                                      'relative group/card': true,
                                                   })
                                                }
                                             >
                                                {
                                                   isInsideModal && (
                                                      <div
                                                         role='presentation'
                                                         onClick={ (e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            onSelectItem(storyCard)
                                                         } }
                                                         className='cursor-pointer hidden absolute top-0 left-0 w-full h-full group-hover/card:!flex justify-center items-center bg-major-60  !z-[3]'>
                                                         <Button
                                                            text='Preview'
                                                            iconName='play-default'
                                                            textColor='divider'
                                                            textSize='small'
                                                            iconPosition='left'
                                                            backgroundColor='transparent'
                                                            classNames='!w-fit !h-9 border border-grey-main items-center'
                                                            borderRadius='large'
                                                            textClassName='mr-0 !leading-[18px]'
                                                            padding='0 px-3.5 py-2'
                                                            onClick={ (e) => {
                                                               e.preventDefault();
                                                               e.stopPropagation();
                                                               handleOpenFullScreen(storyCard.type, storyCard.id)
                                                            } }
                                                         />
                                                      </div>
                                                   )
                                                }
                                                <div
                                                   className='w-full'
                                                   style={ {
                                                      paddingTop: '121.5%',
                                                   } }
                                                />
                                                <div className='h-full flex w-full absolute top-0' >
                                                   {
                                                      storyCard.is_pinned && (
                                                         <PinLabel margin={ 4 } />
                                                      )
                                                   }
                                                   {
                                                      storyCard.type === 'image' ? (
                                                         <Carousel
                                                            type='card'
                                                            data={ storyCard }
                                                            infinite={ true }
                                                            isLoading={ isFetchingDelete && deleteId === storyCard.id }
                                                            openModal={ this.onOpenModal }
                                                            openStoryComments={ () => onClickComment(storyCard.id) }
                                                            onClickJoin={ onClickJoin }
                                                            onClickLike={ onClickLike }
                                                            isAdmin={ true }
                                                            hasAccess={ true }
                                                            identifier={ storyCard.id }
                                                            onClickShare={ onClickShare }
                                                            shareStory={ () => { onClickShare(storyCard.id, storyCard?.title || 'story') } }
                                                            openFullScreenCard={ (type) => handleOpenFullScreen(type, storyCard.id) }
                                                            desktopType={ desktopType }
                                                            onClickOptions={ this.openOptionsModal }
                                                            isAutoplay={ true }
                                                            totalTip={ storyCard.total_tip }
                                                            onClickOpenTips={ onClickOpenTips }
                                                            onClickSetId={ onClickSetId }
                                                            height='full w-full'
                                                            isInsideModal={ isInsideModal }
                                                            isChecked={ !!selections?.includes(storyCard.id) }
                                                            onSelectItem={ _ => onSelectItem(storyCard) }

                                                         />
                                                      ) : (
                                                         <StoryCard
                                                            src={ storyCard.full_src }
                                                            thumbnail={ storyCard.full_thumbnail }
                                                            type={ storyCard.type }
                                                            viewCount={ storyCard.views_count || 0 }
                                                            likeCount={ storyCard.likes_count || 0 }
                                                            title={ storyCard.title }
                                                            date={ storyCard.publish_date }
                                                            timeLeft={ storyCard.time_left }
                                                            hideAfterMinutes={ storyCard.hide_after_minutes }
                                                            timeSector={ storyCard.time_sector }
                                                            openModal={ this.onOpenModal }
                                                            isAdmin={ true }
                                                            deleteStory={ openDeleteConfirmModal }
                                                            identifier={ storyCard.id }
                                                            hasAccess={ true }
                                                            commentsCount={ storyCard.comments_count || 0 }
                                                            openStoryComments={ () => onClickComment(storyCard.id) }
                                                            onClickJoin={ onClickJoin }
                                                            onClickLike={ onClickLike }
                                                            onClickShare={ onClickShare }
                                                            onClickOptions={ this.openOptionsModal }
                                                            openFullScreenCard={ (type) => handleOpenFullScreen(type, storyCard.id) }
                                                            desktopType={ desktopType }
                                                            shareStory={ () => { onClickShare(storyCard.id, storyCard?.title || 'story') } }
                                                            onClickOpenTips={ onClickOpenTips }
                                                            onClickSetId={ onClickSetId }
                                                            data={ storyCard }
                                                            totalTip={ storyCard.total_tip }
                                                            height='full w-full'
                                                            isInsideModal={ isInsideModal }
                                                            isChecked={ !!selections?.includes(storyCard.id) }
                                                            onSelectItem={ _ => onSelectItem(storyCard) }
                                                         />
                                                      )
                                                   }
                                                </div>
                                                {
                                                   openOptionsModal && id === storyCard.id && (
                                                      <OptionsModal
                                                         closeModal={ () => this.openOptionsModal(false) }
                                                         openDeleteConfirmModal={ () => {
                                                            this.openOptionsModal(false)
                                                            onDeleteStory(storyCard.id, null, true)
                                                         }  }
                                                         desktopType={ desktopType }
                                                         id={ storyCard.id }
                                                         shareStory={ () => {
                                                            this.openOptionsModal(false)
                                                            onClickShare(storyCard.id, storyCard?.title || 'story')
                                                         } }
                                                         editStory={ () => {
                                                            this.openOptionsModal(false)
                                                            editStory(storyCard.id, storyCard.type)
                                                         } }
                                                         pinStory={ () => {
                                                            this.openOptionsModal(false)
                                                            pinStory(storyCard.id, storyCard.is_pinned)
                                                         } }
                                                         isPinned={ storyCard.is_pinned }
                                                         isDemoMode={ isDemoMode }
                                                      />
                                                   )
                                                }
                                             </div>
                                       }
                                    </div>
                                 </SortableItem>
                              )

                           })
                        }
                     </ReorderingContent>
                  )
               }
            </div>
            {
               (isLastPage || isFetchingDelete) && (
                  <div
                     style={ isEmpty ? { minHeight: 'calc(100vh - 301px)' } : {} }
                     className='flex  justify-center items-center'>
                     <CircleLoader />
                  </div>
               )
            }
            {
               isEmpty && (
                  <div
                     style={ isEmpty ? { minHeight: 'calc(100vh - 301px)' } : {} }
                     className='flex items-center'>
                     <EmptyState
                        type={ this.searchText === 'filter' ? 'filter' : 'search' }
                        result={  this.searchText }
                     />
                  </div>
               )
            }
            {
               storyPublished &&
               <div className='story-published flex justify-center items-center flex-col text-major-dark font-bold'>
                  <Icon name='circle-checked' color='major-dark' size='3xl' />
                  <p className='mt-3'>Published!</p>
               </div>
            }
            {
               addNewStoryState && (
                  <Modal
                     roundedModal='xlg'
                     contentBgColor='major-dark'
                     contentPosition={ screen > 700 ? 'center' : 'full-screen' }
                     onClose={ () => openAddModal(false) }
                     isCloseAction={ false }
                  >
                     <AddNewStory
                        onCloseAddNewStory={ () => openAddModal(false) }
                        onImagesChange={ onImageChanges }
                        onVideoChange={ onVideoChange }
                        isUploading={ isUploading }
                        isDemoMode={ isDemoMode }
                     />
                  </Modal>
               )
            }
            {
               openModalByUrl && (
                  <Modal
                     fullScreenMode={ isMobileAndTablet() }
                     contentPosition='full-screen'
                     onClose={ () => handleCloseModalByUrl() }
                     className='h-screen'
                  >
                     {
                        isLoadingStory ? (
                           <div className='max-h-screen h-screen w-full bg-secondary flex items-center justify-center'>
                              <CircleLoader color='major-dark' />
                              <div
                                 className='absolute inset-0 w-full h-full'
                                 style={ {
                                    background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 20.05%)',
                                 } }
                              />
                           </div>
                        ) : (
                           <StoryPlayer
                              src={ activeStory.full_src }
                              date={ activeStory.publish_date }
                              hideAfterMinutes={ activeStory.hide_after_minutes }
                              commentsCount={ activeStory.comments_count || 0 }
                              title={ activeStory.title }
                              hasAccess={ true }
                              muted={ false }
                              isAdmin={ true }
                              isLoadingStory={ isLoadingStory }
                              storyType={ activeStory.type }
                              nextStory={ this.nextStory }
                              onClose={ () => handleCloseModalByUrl() }
                              onDeleteStory={ () => onDeleteStory(activeStory.id, null, true) }
                              onDeleteImage={ (index) => onDeleteStory(activeStory.id, index, true) }
                              onClickShare={ () => onClickShare(null, null) }
                              onClickComment={ () => onCommentsClick(activeStory.id) }
                              onClickOpenTips={ onClickOpenTips }
                              onClickSetId={ onClickSetId }
                              id={ activeStory.id }
                              totalTip={ activeStory.total_tip || 0 }
                              onEditStory={ () => editStory(activeStory?.id, activeStory?.type) }
                              onShare={ () => onClickShare(activeStory.id, activeStory?.title || 'story') }
                              pinStory={ () =>  pinStory(activeStory.id, activeStory.is_pinned) }
                              isPinned={ activeStory?.is_pinned }
                              isDemoMode={ isDemoMode }
                              showComments
                           />
                        )
                     }
                  </Modal>
               )
            }
         </div>
      );
   }
}

const OptionsModal = ({
   /* eslint-disable */
   desktopType,
   closeModal,
   openDeleteConfirmModal,
   id,
   shareStory,
   editStory,
   pinStory,
   isPinned,
   isDemoMode,
   /* eslint-enable */
}) => {
   const view = (
      <div
         className={ `shadow dark:shadow-dark story-${ id } flex flex-col w-full bg-panel py-2 items-center justify-between px-5 ${ desktopType === 'mobile' ? '' : 'border border-divider rounded-lg whitespace-nowrap' }` }>
         <div
            className='flex w-full h-12 items-center justify-between'
            role='presentation'
            onClick={ (e) => e.stopPropagation() }
         >
            <Button
               text='Edit story'
               textSize='base'
               textColor='major'
               classNames='h-full w-full'
               iconName='pencil'
               fontIconColor='secondary'
               iconPosition='left'
               alignment='end'
               padding='none'
               backgroundColor='transparent'
               fontIconSize='base'
               onClick={ editStory }
               disabled={ isDemoMode }
               dataToolTipContent={ !!isDemoMode ? 'Not available in demo' : '' }
            />
         </div>
         <div
            className='flex w-full h-12 items-center justify-between'
            role='presentation'
            onClick={ (e) => e.stopPropagation() }
         >
            <Button
               text='Share'
               textSize='base'
               textColor='major'
               classNames='h-full w-full'
               iconName='share'
               fontIconColor='secondary'
               iconPosition='left'
               alignment='end'
               padding='none'
               backgroundColor='transparent'
               fontIconSize='base'
               onClick={ shareStory }
            />
         </div>
         {/* <div
            className='flex w-full h-12 items-center justify-between'
            role='presentation'
            onClick={ (e) => e.stopPropagation() }
         >
            <Button
               text='Copy sharing link'
               textSize='base'
               textColor='major'
               classNames='h-full w-full'
               iconName='copy'
               fontIconColor='secondary'
               iconPosition='left'
               alignment='end'
               padding='none'
               backgroundColor='transparent'
               fontIconSize='base'
               onClick={ shareStory }
            />
         </div> */}
         <div
            className='flex w-full h-12 items-center justify-between'
            role='presentation'
            onClick={ (e) => e.stopPropagation() }
         >
            <Button
               text={ !isPinned ? 'Pin story' : 'Unpin story' }
               textSize='base'
               textColor='major'
               classNames='h-full w-full'
               iconName={ !isPinned ? 'pin' : 'unpin' }
               fontIconColor='secondary'
               iconPosition='left'
               alignment='end'
               padding='none'
               backgroundColor='transparent'
               fontIconSize='base'
               onClick={ pinStory }
            />
         </div>
         <div
            className='flex w-full h-12 items-center justify-between'
            role='presentation'
            onClick={ (e) => e.stopPropagation() }
         >
            <Button
               text='Delete this story'
               onClick={ openDeleteConfirmModal }
               iconName='delete'
               fontIconSize='base'
               iconPosition='left'
               classNames='h-full w-full'
               backgroundColor='transparent'
               fontIconColor='error'
               textColor='error'
               padding='none'
               alignment='end'
               disabled={ isDemoMode }
               dataToolTipContent={ !!isDemoMode ? 'Not available in demo' : '' }
            />
         </div>
      </div>
   )
   if(desktopType === 'mobile'){
      return (
         <Modal
            onClose={ closeModal }
            roundedModal='lg'
         >
            {view}
         </Modal>
      );
   } else {
      return (
         <div
            style={ { bottom: '-120px', right: '0', zIndex: '11' } }
            className='absolute min-w-[288px]'>
            {view}
         </div>
      )
   }

}

export default Stories;
